import React, { useCallback, useState, useEffect } from 'react';
import { useHistory, withRouter } from 'react-router';
import {
    ValidateSpanishID,
    validateEmail,
    stringIsNullOrEmpty,
    ValidateSpanishIDNoCif
} from '../utils/validations';
import inputValidations, { validateInput } from '../utils/inputsValidations';
import { InsertFlotaClient } from '../services/registerService';
import { GetCategories } from '../services/listsService';
import { GetCompaniesCarpolicy } from '../services/listsService';
import toJson from 'enzyme-to-json';
import Globals from '../Globals';
import Modal from '../Components/Modal';



let validations = inputValidations.validations;

const NewUserForm = ({
    setIsLoading
}) => {
    const [nifNieUserError, setNifNieUserError] = useState(null);
    const [nombreUserError, setNombreUserError] = useState(null);
    const [pApellidoError, setPApellidoError] = useState(null);
    const [sApellidoError, setSApellidoError] = useState(null);
    const [correoUserError, setCorreoUserError] = useState(null);
    const [CategoryError, setCategoryError] = useState(null);
    const [pPoliticasCheck, setPoliticasCheck] = useState(null);

    const [Nombre, setUserName] = useState(null);
    const [Apellido1, setUserSurname1] = useState(null);
    const [Apellido2, setUserSurname2] = useState(null);
    const [categoryList, setCategoryList] = useState([]);
    const [companyCarpolicyList, setCompanyCarpolicyList] = useState([]);
    const history = useHistory();
    const [hideModal, setHideModal] = useState(true);
    const [modalTitulo, setmodalTitulo] = useState("");
    const [modalText, setmodalText] = useState("");
    const [companyValue, setcompanyValue] = useState("");
    const [categoryValue, setcategoryValue] = useState("");

    const InsertFSCARSFlotaClient = () => {
        setIsLoading(true);
        
        var jsonData = "{";
        var inputs = document.forms['main-form'].getElementsByTagName('input');
        Array.from(inputs).forEach(element => {
            jsonData += "\"" + element.id + "\":\"" +  element.value + "\",";
        });

        var salects = document.forms['main-form'].getElementsByTagName('select');
        // Array.from(salects).forEach(element => {
        //     jsonData += "\"" + element.id + "\":" +  element.value;
        //     if (element.id == "Empresa")
        //     {
        //         jsonData += ",";
        //     }
        // });
        var empresa = Array.from(salects)[0];
        var categoria = Array.from(salects)[1];
        jsonData += "\"" + empresa.id + "\":" +  empresa.value + ",";
        jsonData += "\"" + categoria.id + "\":" +  categoria.value + "}";
        InsertFlotaClient(JSON.parse(jsonData))
            .then(response => {
                if (response == 1) {
                    history.push(Globals.APPLICATION_PATH.COMPLETED);
                }
                else if (response == 2)
                {                        
                    history.push(Globals.APPLICATION_PATH.NOCOMPLETED);
                }
                else {
                    history.push(Globals.APPLICATION_PATH.ERROR);
                }
            })
            .catch(() => history.push(Globals.APPLICATION_PATH.ERROR))
            .finally(() => setIsLoading(false));
                
        return;
    };

    const inputsNecessaryFilled = async () => {
        //Validación si los inputs obligatorios están rellenados
        console.log(document.getElementById('TOS').checked);
        var politicasCheck = document.getElementById('TOS').checked;
        if (!politicasCheck)
        {
            setPoliticasCheck('Debe aceptar las condiciones');
        }
        else 
        {
            setPoliticasCheck(null);
        }

        if (isFormValidated())
        {
            
            var EmailValid = validateEmail(document.getElementById('Email').value) 
            if (!EmailValid)
            {
                setCorreoUserError('Email incorrecto');
            }
            if (politicasCheck & EmailValid)
            {
                InsertFSCARSFlotaClient();
            }
            
        }
    };

    const isFormValidated = () => {
        return (
            validateInput(
                'NIF',
                setNifNieUserError,
                validations.NIFNIE,
                ValidateSpanishIDNoCif
            )
            &
            validateInput(
                'Nombre',
                setNombreUserError,
                validations.NOMBRE
            )
            &
            validateInput(
                'Apellido1',
                setPApellidoError,
                validations.APELLIDO
            )
            &
            validateInput(
                'Email',
                setCorreoUserError,
                validations.CORREO
            )
            &
            validateInput(
                'Categoria',
                setCategoryError,
                validations.CATEGORIA
            )
        )
    }

    const onChangeOnlyLetters = useCallback(e => {
        const re = /^[A-Za-zñÑ.ºª\s]+$/;

        switch(e.target.id) {
            case "Nombre":
                if (!re.test(e.target.value) && e.target.value !== "") {
                    document.getElementById(e.target.id).value = Nombre;
                } else if (e.target.value === "") {
                    document.getElementById(e.target.id).value = "";
                } else {
                    setUserName(e.target.value);
                }
                e.target.value !== ''
                ? setNombreUserError(null)
                : setNombreUserError(validations.NOMBRE)
                break;
            case "Apellido1":
                if (!re.test(e.target.value) && e.target.value !== "") {
                    document.getElementById(e.target.id).value = Apellido1;
                } else if (e.target.value === "") {
                    document.getElementById(e.target.id).value = "";
                } else {
                    setUserSurname1(e.target.value);
                }

                e.target.value !== ''
                ? setPApellidoError(null)
                : setPApellidoError(validations.APELLIDO)
                break;
            case "Apellido2":
                if (!re.test(e.target.value) && e.target.value !== "") {
                    document.getElementById(e.target.id).value = Apellido2;
                } else if (e.target.value === "") {
                    document.getElementById(e.target.id).value = "";
                } else {
                    setUserSurname2(e.target.value);
                }

                e.target.value !== ''
                ? setSApellidoError(null)
                : setSApellidoError(validations.APELLIDO)
                break;
            default:
            break;
        }
    }, [Nombre, Apellido1, Apellido2]);

    useEffect(() => {
        GetCategories()
        .then(result => {
            if (result) {
                let Categories = JSON.parse(result);
                setCategoryList(Categories);
            }
        })
        .catch(error => {
            return error;
        });
    }, []);

    useEffect(() => {
        GetCompaniesCarpolicy()
        .then(result => {
            if (result) {
                let CompaniesCarpolicy = JSON.parse(result);
                setCompanyCarpolicyList(CompaniesCarpolicy);
            }
        })
        .catch(error => {
            return error;
        });
    }, []);
    
    const onCompanyChange = (event) => {
        const value = event.target.value;
        setcompanyValue(value);
    }

    const onCategoryChange = (event) => {
        const value = event.target.value;
        setcategoryValue(value);
    }

    return (
        <React.Fragment>
            <div className="c-form-field u-mt">
                <div className="o-layout">
                    <div className="o-layout__item u-1/2">
                        <label
                            htmlFor="NIF"
                            className="c-form-field__label"
                        >
                            <strong> NIF/NIE </strong>
                        </label>
                        <div className="c-form-field__box">
                            <div className="c-input  ">
                                <input
                                    className="c-input__input"
                                    id="NIF"
                                    type="text"
                                    placeholder=""
                                    data-tr-component="Input Field"
                                    data-tr-function="Text Input"
                                    maxLength="9"
                                    onChange={e =>
                                        setNifNieUserError(
                                            ValidateSpanishIDNoCif(e.target.value)
                                                ? null
                                                : validations.NIFNIE
                                        )
                                    }
                                />
                            </div>
                            <p
                                className="c-error-message"
                                id="correo1Input-error"
                            >
                                {' '}
                                {nifNieUserError}{' '}
                            </p>
                        </div>
                    </div>
                    <div className="o-layout__item u-1/2 u-1/1@xs">
                        <label
                            htmlFor="Nombre"
                            className="c-form-field__label"
                        >
                            <strong> Nombre </strong>
                        </label>
                        <div className="c-form-field__box">
                            <div className="c-input  ">
                                <input
                                    className="c-input__input"
                                    id="Nombre"
                                    type="text"
                                    placeholder=""
                                    data-tr-component="Input Field"
                                    data-tr-function="Text Input"
                                    onChange={e => onChangeOnlyLetters(e)}
                                />
                            </div>
                            <p
                                className="c-error-message"
                                id="correo1Input-error"
                            >
                                {' '}
                                {nombreUserError}{' '}
                            </p>
                        </div>
                    </div>
                    <div className="o-layout__item u-1/2 u-1/1@xs">
                        <label
                            htmlFor="Apellido1"
                            className="c-form-field__label"
                        >
                            <strong> Primer Apellido </strong>
                        </label>
                        <div className="c-form-field__box">
                            <div className="c-input  ">
                                <input
                                    className="c-input__input"
                                    id="Apellido1"
                                    type="text"
                                    placeholder=""
                                    data-tr-component="Input Field"
                                    data-tr-function="Text Input"
                                    onChange={e => onChangeOnlyLetters(e)}
                                />
                            </div>
                            <p
                                className="c-error-message"
                                id="correo1Input-error"
                            >
                                {' '}
                                {pApellidoError}{' '}
                            </p>
                        </div>
                    </div>
                    <div className="o-layout__item u-1/2 u-1/1@xs">
                        <label
                            htmlFor="Apellido2"
                            className="c-form-field__label"
                        >
                            <strong> Segundo Apellido </strong>
                        </label>
                        <div className="c-form-field__box">
                            <div className="c-input  ">
                                <input
                                    className="c-input__input"
                                    id="Apellido2"
                                    type="text"
                                    placeholder=""
                                    data-tr-component="Input Field"
                                    data-tr-function="Text Input"
                                    onChange={e => onChangeOnlyLetters(e)}
                                />
                            </div>
                            <p
                                className="c-error-message"
                                id="correo1Input-error"
                            >
                                {' '}
                                {sApellidoError}{' '}
                            </p>
                        </div>
                    </div>
                    <div className="o-layout__item u-2/2 u-1/1@xs">
                        <label
                            htmlFor="Email"
                            className="c-form-field__label"
                        >
                            <strong> Correo </strong>
                        </label>
                        <div className="c-form-field__box">
                            <div className="c-input  ">
                                <input
                                    className="c-input__input"
                                    id="Email"
                                    type="text"
                                    placeholder=""
                                    data-tr-component="Input Field"
                                    data-tr-function="Text Input"
                                    onChange={e =>
                                        validateEmail(e.target.value) === true
                                            ? setCorreoUserError(null)
                                            : setCorreoUserError('Email incorrecto')
                                    }
                                />
                            </div>
                            <p
                                className="c-error-message"
                                id="Email-error"
                            >
                                {' '}
                                {correoUserError}{' '}
                            </p>
                        </div>
                    </div>
                    <div className="o-layout__item u-1/2 u-1/1@xs">
                        <label
                            htmlFor="Empresa"
                            className="c-form-field__label"
                        >
                            <strong> Empresa </strong>
                        </label>
                        <div className="c-form-field__box">
                            {
                                <div className="c-form-field__box">
                                    <div className="c-input  c-input--select">
                                        <select
                                            id="Empresa"
                                            className="c-input__input"
                                            value={companyValue}
                                            onChange={onCompanyChange}
                                        >
                                            <option defaultValue disabled key='' value=''>Seleccione Empresa</option>
                                            {companyCarpolicyList.length > 0
                                                ? Object.keys(
                                                        companyCarpolicyList
                                                    ).map(function (
                                                        key,
                                                        index
                                                    ) {
                                                        return (
                                                            <option
                                                                key={
                                                                    key
                                                                }
                                                                value={
                                                                    companyCarpolicyList[
                                                                        index
                                                                    ]
                                                                        .id
                                                                }
                                                            >
                                                                {
                                                                    companyCarpolicyList[
                                                                        index
                                                                    ]
                                                                        .description
                                                                } 
                                                            </option>
                                                        );
                                                    })
                                                : null}
                                        </select>
                                    </div>
                                    <p className="c-error-message">
                                        {' '}
                                        {CategoryError}{' '}
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="o-layout__item u-1/2 u-1/1@xs">
                        <label
                            htmlFor="Categoria"
                            className="c-form-field__label"
                        >
                            <strong> Categoria </strong>
                        </label>
                        <div className="c-form-field__box">
                            {
                                <div className="c-form-field__box">
                                    <div className="c-input  c-input--select">
                                        <select
                                            id="Categoria"
                                            className="c-input__input"
                                            value={categoryValue}
                                            onChange={onCategoryChange}
                                        >
                                            <option defaultValue disabled key='' value=''>Seleccione Categoria</option>
                                            {categoryList.length > 0
                                                ? Object.keys(
                                                        categoryList
                                                    ).map(function (
                                                        key,
                                                        index
                                                    ) {
                                                        return (
                                                            <option
                                                                key={
                                                                    key
                                                                }
                                                                value={
                                                                    categoryList[
                                                                        index
                                                                    ]
                                                                        .id
                                                                }
                                                            >
                                                                {
                                                                    categoryList[
                                                                        index
                                                                    ]
                                                                        .description
                                                                }
                                                            </option>
                                                        );
                                                    })
                                                : null}
                                        </select>
                                    </div>
                                    <p className="c-error-message">
                                        {' '}
                                        {CategoryError}{' '}
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div className='o-fieldset__row'>
                <table class="TextoLegal">
                    <thead>
                        <td colSpan="2"><strong>Información básica sobre protección de datos</strong></td>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Responsable</td>
                            <td>Volkswagen Renting, S.A.<br/>Avda. de Bruselas, 34. 28108 - Alcobendas (Madrid)<br/>CIF A80185051<br/>DPO.es@vwfs.com
                        </td>
                        </tr> 
                        <tr>
                            <td>Finalidad</td>
                            <td>Gestión del registro en FSCars (<span onClick={() => setHideModal(false) }>+info</span>)</td>
                        </tr>
                        <tr>
                            <td>Legitimación</td>
                            <td>Gestión de la solicitud (<span onClick={() => setHideModal(false) }>+info</span>)</td>
                        </tr>
                        <tr>
                            <td>Origen de los datos</td>
                            <td>Volkswagen Financial Services o la entidad empleadora que corresponda. En caso de amigo/familiar, empleados del Grupo Volkswagen.</td>
                        </tr>
                        <tr>
                            <td>Categorias de datos tratadas</td>
                            <td>Datos identificativos y de contacto; características personales; circunstancias personales; detalles de empleo y otras tipologías de datos imprescindibles para gestionar el alta como cliente.</td>
                        </tr>
                        <tr>
                            <td>Destinatarios</td>
                            <td>No se prevén cesiones de datos.</td>
                        </tr>
                        <tr>
                            <td>Derechos</td>
                            <td>Acceder, rectificar, oponerse, limitar el tratamiento, portabilidad y suprimir datos, conforme a lo dispuesto en la información adicional (<span onClick={() => setHideModal(false) }>+info</span>)</td>
                        </tr>
                        <tr>
                            <td>Información adicional</td>
                            <td>Ver información detallada a continuación (<span onClick={() => setHideModal(false) }>+info</span>)</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="fieldset__row">
                <div class="checkbox">
                    <ul class="o-list-inline">
                        <li>
                            <label>
                                <input class="c-checkbox" id="TOS" name="cTOS" type="checkbox" value="S"/>
                                <span>   He leido los datos del aviso legal y acepto las condiciones</span>
                            </label>
                        </li>
                    </ul>
                </div>
                <p
                    className="c-error-message"
                    id="politicasInput-error"
                >
                    {' '}
                    {pPoliticasCheck}{' '}
                </p>
            </div>
            <br/>
            <div className="o-layout o-layout--right">
                <div className="o-layout__item u-12/12 u-12/12@s u-12/12@xs">
                    <div className="c-form-field">
                        <button
                            className="c-btn"
                            onClick={inputsNecessaryFilled}
                        >
                            <span className="c-btn__text">Solicitar acceso</span>
                        </button>
                    </div>
                </div>
            </div>
            <Modal buttonText={"Cerrar"} titleText={"Información detallada de protección de datos"} hideModal={hideModal} onToggle={ () => setHideModal(true)}>
            <p>
            Le informamos que Volkswagen Renting, S.A., con CIF A80185051, domicilio social en Avda. de Bruselas, 34. 28108 - Alcobendas (Madrid) y correo electrónico DPO.es@vwfs.com tratará sus datos personales comunicados por Volkswagen Financial Services o a la entidad empleadora que corresponda a su solicitud, así como aquellos suministrados en el presente formulario y los que suministre en el futuro por cualquier medio o en virtud de otras comunicaciones o relaciones contractuales, incluyendo los resultantes de procesos informáticos derivados de los registrados, con la finalidad del acceso y gestión de las ofertas de renting del vehículo seleccionado por Ud. y/o adquisición, en su caso, de vehículos y prestación de servicios relacionados directa o indirectamente con las mismos. La base legitimadora del tratamiento es la gestión y desarrollo de la relación jurídica entablada, así como la ejecución de las medidas precontractuales solicitadas por Ud.<br/><br/>En el caso de que se faciliten datos de terceros, Ud. declara que los mismos son ciertos y manifiesta haber informado previamente a dichas personas sobre el contenido de esta cláusula y obtenido su consentimiento inequívoco para ello cuando así fuera necesario, circunstancia que deberá poder acreditar.<br/><br/>Los datos personales tratados podrán incluir datos identificativos y de contacto; características personales; circunstancias personales; detalles de empleo y otras tipologías de datos imprescindibles para gestionar su alta como cliente. Le informamos que Volkswagen Renting, S.A., no prevé las comunicaciones de sus datos a terceros para alcanzar la finalidad referida.<br/><br/>Asimismo, le informamos que para cumplir con la finalidad descrita no se efectuarán transferencias internacionales de datos a terceros países u organizaciones internacionales. En caso de ser necesario transferir datos para cumplir con las finalidades descritas, le informaremos dicha situación implementando todas las garantías necesarias, incluyendo la suscripción de cláusulas contractuales tipo de la Comisión Europea, códigos de conducta y cualesquier otras garantías que resulten necesarias.<br/><br/>Sus datos personales serán conservados únicamente durante el periodo necesario para alcanzar la finalidad en cuestión. En el supuesto de que la operación no llegue a formalizarse, sus datos podrán conservarse durante un periodo de tiempo razonable, que se estima en 12 meses, a fin de evitar duplicidad de gestiones en caso de nuevas solicitudes y el tiempo necesario para cumplir las obligaciones legales.<br/><br/>Se podrá ejercitar los derechos de acceso, rectificación o supresión, oposición y portabilidad de los datos, bien por correo postal a Volkswagen Renting, S.A. a la dirección indicada arriba o por correo electrónico a clientes.renting@vwfs.com. Asimismo, y en las mismas direcciones, Ud. podrá solicitar la limitación del tratamiento de sus datos en los casos legalmente previstos. Igualmente, puede contactar con nuestro Delegado de Protección de Datos en la siguiente dirección DPO.es@vwfs.com.<br/><br/><br/>Asimismo, podrá dirigirse a la Agencia Española de Protección de Datos en www.aepd.es.
            </p>
            </Modal>
        </React.Fragment>
    );
};

export default withRouter(NewUserForm);
